import { UserList } from './UserList';
import { UserShow } from './UserShow';
import Icon from '@material-ui/core/Icon';
import Box from '@material-ui/core/Box';

const usersResource = {
  list: UserList,
  show: UserShow,
  icon: () => <Icon><Box component="img" src='icons/users.svg' /></Icon>,
};

export default usersResource;